import { ICustomProductOptionConfig } from "@evennt-tech/api-v2-core";
import {
  IGetAllCustomProductOptionConfigsQueryReq,
  IGetCustomProductOptionConfigsPaginatedQueryReq,
} from "@evennt-tech/api-v2-external";
import { apiV2 } from "api/firebase";

// The paginated endpoint caps `limit` at 500.
const CUSTOM_CONFIGS_PAGE_LIMIT = 500;

export const customProductOptionConfigRepository = {
  getAllCustomConfigsForProduct: (
    params: IGetAllCustomProductOptionConfigsQueryReq
  ) => apiV2.customProductOption.config.custom.getAllByProduct(params),
  getCustomConfigsPage: (
    params: IGetCustomProductOptionConfigsPaginatedQueryReq
  ) => apiV2.customProductOption.config.custom.getPaginated(params),
  /**
   * Every enabled CUSTOM config of ONE product with that show's overrides —
   * the rows of a matrix the product lists leave out (see
   * hasLazyCustomConfigs), loaded only when a view needs them.
   */
  getEnabledCustomConfigsForShow: async (
    params: Omit<
      IGetCustomProductOptionConfigsPaginatedQueryReq,
      "page" | "limit"
    > & { showId: string }
  ): Promise<ICustomProductOptionConfig[]> => {
    const getPage = (page: number) =>
      apiV2.customProductOption.config.custom.getPaginated({
        ...params,
        page,
        limit: CUSTOM_CONFIGS_PAGE_LIMIT,
      });
    const firstPage = await getPage(1);
    const otherPages = await Promise.all(
      Array.from(
        { length: Math.max(0, (firstPage.meta.totalPages ?? 1) - 1) },
        (_, i) => getPage(i + 2)
      )
    );

    return [firstPage, ...otherPages].flatMap(({ items }) => items);
  },
};
